import { styled } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";
import { EmailOutlined, NorthEast } from "@mui/icons-material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const ContentBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const GridContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  alignItems: "center",
  gap: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const BookImageContainer = styled(Box)(({ theme }) => ({
  background: "#fff",
  borderRadius: "33px",
  maxWidth: "400px",
  [theme.breakpoints.down("md")]: {
    justifySelf: "center",
  },
}));

export const BookImage = styled("img")(({ theme }) => ({
  padding: theme.spacing(2),
  width: "100%",
  maxWidth: "400px",
  height: "auto",
  aspectRatio: "2/3",
  borderRadius: "33px",
  objectFit: "cover",

  [theme.breakpoints.down("md")]: {
    margin: "0 auto",
    display: "block",
  },
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
    margin: "0 auto",
    display: "block",
  },
}));

export const BookCard = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.text.primary}`,
  borderRadius: theme.spacing(2),
  cursor: "pointer",
  [theme.breakpoints.down("md")]: {
    maxWidth: "400px",
    margin: `${theme.spacing(2)} auto`,
    padding: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
}));

export const BookCardHeader = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const AnnouncementTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "18px",
  fontWeight: "400",
  textTransform: "uppercase",
  [theme.breakpoints.down(1150)]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));

export const NorthEastIcon = styled(NorthEast)(({ theme }) => ({
  fontSize: "28px",
  color: theme.palette.text.primary,
}));

export const BookTitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontWeight: "700",
  color: theme.palette.text.primary,
  lineHeight: "1.5",
  fontSize: "32px",
  [theme.breakpoints.down(1150)]: {
    fontSize: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(2),
  },
}));

export const EmailCard = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2),
  border: `0.25px solid ${theme.palette.text.primary}`,
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(2),
  transition: "all 0.3s ease",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  gap: theme.spacing(2),
  cursor: "pointer",
  borderRadius: theme.spacing(2),

  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  "&:active": {
    backgroundColor: theme.palette.action.selected,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.15)",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

export const StyledEmailIcon = styled(EmailOutlined)(({ theme }) => ({
  fontSize: "24px",
  color: theme.palette.text.primary,
}));

export const EmailCardTitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Gotham', sans-serif",
  fontSize: "18px",
  textTransform: "uppercase",
  lineHeight: "20px",
  wordBreak: "break-word",
}));

export const EmailAddressTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Gotham', sans-serif",
  textTransform: "uppercase",
  textDecorationLine: "underline",
  wordBreak: "break-word",
  [theme.breakpoints.up("md")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.between("sm", "md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const EmailCardSubtitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Quicksand', sans-serif",
  fontSize: theme.spacing(2),
  fontWeight: "400",
  wordBreak: "break-word",
}));

export const NorthEastIconSmall = styled(NorthEast)(({ theme }) => ({
  fontSize: "24px",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));
